import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-type-intervention-detail',
  templateUrl: './type-intervention-detail.component.html',
  styleUrls: ['./type-intervention-detail.component.scss']
})
export class TypeInterventionDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
